export default [
  { text: "product.product_type.COURSE", value: "COURSE" },
  { text: "product.product_type.ADHOC_ONE", value: "ADHOC_ONE" },
  { text: "product.product_type.ADHOC_TWO", value: "ADHOC_TWO" },
  { text: "product.product_type.ADHOC_GROUP", value: "ADHOC_GROUP" },
];
